import React from 'react';
import { isBordo, toggleTheme } from './theme';

// Sun in the dark theme (go light), moon in the light theme (go dark).
const ThemeToggle = ({ className }) => {
  const dark = isBordo();
  const label = dark ? 'Açık tema' : 'Koyu tema';
  return (
    <button type="button" className={className} onClick={toggleTheme} aria-label={label} title={label}>
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
        {dark ? (
          <>
            <circle cx="12" cy="12" r="4.2" />
            {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
              <line key={a} x1="12" y1="2.6" x2="12" y2="5" transform={`rotate(${a} 12 12)`} />
            ))}
          </>
        ) : (
          <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
        )}
      </svg>
    </button>
  );
};

export default ThemeToggle;
